interface IFormatPriceOptions {
  fractionDigits?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  currencyCode?: string;
}

export default function formatPrice(
  val: string | number,
  {
    fractionDigits,
    minimumFractionDigits,
    maximumFractionDigits,
    currencyCode,
  }: IFormatPriceOptions = { fractionDigits: 2 }
): string {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode || 'USD',
    minimumFractionDigits: minimumFractionDigits || fractionDigits,
    maximumFractionDigits: maximumFractionDigits || fractionDigits,
  }).format(Number(val));
}
